var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlurb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 154,
    viewBox: "0 0 202 154",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.4811,
    cy: 77.08,
    r: 76.2711,
    fill: "#FFD561"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.607 77.512V124.569C152.607 126.527 151.203 128.113 149.466 128.113H78.1437C76.412 128.113 74.9976 126.527 74.9976 124.569V77.512H152.607Z",
    fill: "#7D6378",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.144 145.554L194.387 104.703L132.214 5.40427L66.9703 46.2547L129.144 145.554Z",
    fill: "#A2E6CB",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.782 75.9519L117.559 105.52",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.741 85.4119L122.549 115.588",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.523 94.8718L128.981 124.639",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.425 22.6566V31.7507H44.7412V22.6566C44.7412 20.6937 46.3331 19.1072 48.2907 19.1072H133.875C135.833 19.1072 137.425 20.6937 137.425 22.6566Z",
    fill: "#FF6D54",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7544 28.9489C54.4325 28.9489 55.7929 27.5885 55.7929 25.9104C55.7929 24.2322 54.4325 22.8718 52.7544 22.8718C51.0762 22.8718 49.7158 24.2322 49.7158 25.9104C49.7158 27.5885 51.0762 28.9489 52.7544 28.9489Z",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.791 97.0015L174.608 103.831",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.419 31.7456V86.875C137.419 88.8326 135.828 90.4244 133.87 90.4244H48.2853C46.3277 90.4244 44.7358 88.8326 44.7358 86.875V52.811L78.3803 31.7456H137.419Z",
    fill: "white",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.148 65.0619H156.151V55.8119C156.151 54.3921 157.42 53.2466 158.985 53.2466H198.319C199.884 53.2466 201.148 54.3921 201.148 55.8119V65.0619Z",
    fill: "white",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.148 65.0564V107.709C201.148 109.129 199.884 110.28 198.319 110.28H158.985C157.42 110.28 156.151 109.129 156.151 107.709V65.0564H201.148Z",
    fill: "#9EB6BA",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2946 105.321V111.398C79.2946 113.356 77.3101 114.942 74.8739 114.942H62.51C60.0684 114.942 58.0947 113.356 58.0947 111.398V105.321H79.2946Z",
    fill: "#9EB6BA",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2946 85.9069V105.321H58.0894V85.9069C58.0894 83.9493 60.0631 82.3628 62.5047 82.3628H74.8686C76.9498 82.3628 78.6923 83.5137 79.1602 85.0625C79.2462 85.3314 79.2946 85.6165 79.2946 85.9069Z",
    fill: "white",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7324 113.049C70.4105 113.049 71.7709 111.689 71.7709 110.011C71.7709 108.333 70.4105 106.972 68.7324 106.972C67.0542 106.972 65.6938 108.333 65.6938 110.011C65.6938 111.689 67.0542 113.049 68.7324 113.049Z",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.295 35.8486V41.6246C171.295 44.0124 169.209 45.9484 166.649 45.9484H153.656C151.091 45.9484 149.015 44.0124 149.015 41.6246V35.8486H171.295Z",
    fill: "white",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.917 35.8489H149.015V12.0461L163.917 35.8489Z",
    fill: "white",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.657 44.475C161.335 44.475 162.696 43.1146 162.696 41.4365C162.696 39.7583 161.335 38.3979 159.657 38.3979C157.979 38.3979 156.619 39.7583 156.619 41.4365C156.619 43.1146 157.979 44.475 159.657 44.475Z",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0709 56.2901C86.6784 58.8769 84.3497 60.7807 83.3333 59.5653C82.7471 58.8608 83.5699 57.1076 82.7471 55.8276C81.6984 54.1873 79.8268 51.3854 79.9452 51.9716C80.0635 52.5471 79.6332 56.9462 78.918 58.9199V49.5193H85.0865C85.5544 50.5626 87.5334 53.2139 87.0709 56.2901Z",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.522 49.5193V56.1449L78.9185 70.2997V58.9199C79.6337 56.9462 80.064 52.5471 79.9456 51.9716C79.8273 51.3854 81.6989 54.1873 82.7476 55.8276C83.5704 57.1076 82.7476 58.8608 83.3338 59.5653C84.3502 60.7807 86.6788 58.8769 87.0714 56.2901C87.5339 53.2139 85.5548 50.5626 85.087 49.5193H101.522Z",
    fill: "#9EB6BA",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.899 31.7615C103.969 34.2138 100.667 38.4086 100.505 38.656C100.269 39.0056 100.737 44.7277 97.8163 47.7663C97.4936 48.1051 97.0903 48.7289 96.6385 49.5195H90.7604C91.2552 47.7716 91.5187 45.9808 90.5722 45.7818C89.9914 45.6527 87.7703 48.2341 85.0867 49.0516C84.9469 49.0946 84.9684 49.256 85.0867 49.5195C85.5546 50.5628 87.5337 53.2141 87.0712 56.2903C86.6786 58.8771 84.3499 60.7809 83.3335 59.5655C82.7473 58.861 83.5701 57.1078 82.7473 55.8278C81.6986 54.1875 79.8271 51.3856 79.9454 51.9718C80.0637 52.5473 79.6335 56.9464 78.9182 58.9201C78.9128 58.9416 78.9021 58.9578 78.8967 58.9793C77.8426 61.7812 75.1751 61.437 75.3903 60.028C75.8581 56.9948 75.8581 53.9563 75.7398 54.7737C75.6215 55.5912 73.8737 58.9793 72.2388 59.4472C70.5985 59.915 70.2489 58.6297 70.7168 57.4627C71.1847 56.2903 70.5985 50.4499 71.416 48.4654C72.0559 46.9165 80.4402 36.3381 84.0972 31.7615H105.899Z",
    fill: "white",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9455 51.9717C78.1923 48.3524 79.3593 45.9 81.93 44.2651",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7402 54.774C75.1863 49.7778 73.7558 46.4812 78.3109 43.4426",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M100.505 38.6562L98.9834 39.1241",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3803 31.7456L44.7358 52.811V31.7456H78.3803Z",
    fill: "#DF6286",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.521 56.1453V70.5474H78.918V70.3L101.521 56.1453Z",
    fill: "#DF6286",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M171.295 10.5077V35.8486H163.917L149.015 12.0458V10.5077C149.015 8.1199 151.091 6.18384 153.656 6.18384H166.649C168.827 6.18384 170.661 7.58749 171.156 9.48052C171.247 9.80858 171.295 10.1528 171.295 10.5077Z",
    fill: "#E06287",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8901 91.3924C74.8901 97.3942 70.023 102.256 64.0266 102.256C61.8378 102.256 59.7942 101.61 58.0894 100.492V85.9069C58.0894 83.9493 60.0631 82.3628 62.5047 82.3628H70.0553C72.9701 84.3096 74.8901 87.6278 74.8901 91.3924Z",
    fill: "#DF6286",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M165.369 68.8159H189.639C189.715 68.8159 189.768 68.8966 189.731 68.9611L178.152 90.2363C178.114 90.3062 178.018 90.3062 177.974 90.2417L165.283 68.9665C165.234 68.902 165.288 68.8159 165.369 68.8159Z",
    fill: "#DF6286",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M193.764 110.28H171.01C170.827 107.499 170.72 103.39 171.048 101.589C171.833 97.238 174.791 97.4208 174.791 96.996C174.791 95.5708 174.909 81.771 177.851 81.771C180.626 81.771 180.061 95.3181 179.959 97.3886C179.959 97.4101 179.997 97.4208 180.007 97.3939C180.223 96.5173 181.056 93.6778 182.643 93.6778C184.579 93.6778 184.885 96.2215 184.934 97.2326C184.934 97.2703 184.993 97.2756 184.998 97.2326C185.154 96.3399 185.687 94.2801 187.3 94.2801C188.956 94.2801 189.284 96.883 189.344 97.4854C189.349 97.5069 189.381 97.5123 189.392 97.4908C189.543 97.0713 190.15 95.6676 191.586 95.6676C193.813 95.6676 193.936 104.902 193.764 110.28Z",
    fill: "white",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.809 62.2494C164.487 62.2494 165.848 60.889 165.848 59.2109C165.848 57.5328 164.487 56.1724 162.809 56.1724C161.131 56.1724 159.771 57.5328 159.771 59.2109C159.771 60.889 161.131 62.2494 162.809 62.2494Z",
    stroke: "#3D3935",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurb);
export default __webpack_public_path__ + "static/media/Blurb.410f3b8b4a2e4f799d19f5e77c60e59f.svg";
export { ForwardRef as ReactComponent };